/// <reference path="../../../node_modules/@types/node/index.d.ts" />

import { h } from 'preact';
import { IEmptyState, ISgwtMiniFooterContactUs } from '../sgwt-mini-footer.types';
import { ComponentWithDropdown } from '../../common/ComponentWithDropdown';
import { widgetConfiguration } from '@sgwt-widget/core';
import { registerMiniFooterEvent } from '../../common/monitoring';

const NavDropdown = require('react-bootstrap/lib/NavDropdown');
const MenuItem = require('react-bootstrap/lib/MenuItem');
const NavItem = require('react-bootstrap/lib/NavItem');

export default class ContactUs extends ComponentWithDropdown<ISgwtMiniFooterContactUs, IEmptyState> {
  constructor(props: ISgwtMiniFooterContactUs) {
    super(props);
  }

  openHelpCenter(props: ISgwtMiniFooterContactUs) {
    const selector = props.contactUsByHelpCenter || 'sgwt-help-center';
    const elt = document.querySelector(selector);
    if (elt) {
      (elt as any).form();
      registerMiniFooterEvent('contacts.open-help-center');
    } else {
      registerMiniFooterEvent('contacts.open-help-center.error');
      widgetConfiguration().warn('You have configured the sgwt-mini-footer to use the help center, ' +
        'but it was not found with the selector "' + selector + '".');
    }
  }

  render(props: ISgwtMiniFooterContactUs): JSX.Element {
    const contactList = props.contactList;
    if (props.contactUsByHelpCenter !== undefined) {
      return <NavItem onClick={() => { this.openHelpCenter(props); }}>{props.label}</NavItem>;
    }
    if (contactList) {
      let mail = `mailto:${contactList.mail || ''}`;
      let delimiter;
      let mailMenuItem;
      if (contactList.phones) {
        if (contactList.mail) {
          delimiter = <MenuItem divider/>;
          mailMenuItem = <MenuItem href={mail}><strong>EMAIL:</strong>{ contactList.mail }</MenuItem>;
        }
        return (
          <NavDropdown
            title={props.label}
            id="sgwt-mini-footer-contact-us-dropup"
            dropup
            onClick={(evt: any) => this.horribleDropdownHack(evt)}
          >
            { contactList.phones.map(phone => <MenuItem href={`tel:${phone.value}`}><b>{ phone.label.toUpperCase() }:</b>{phone.value}</MenuItem>)}
            { delimiter }
            { mailMenuItem }
          </NavDropdown>
        );
      } else {
        return (
          <NavItem href={mail}>{props.label}</NavItem>
        );
      }
    }
    return (
      <NavItem href="mailto:">{props.label}</NavItem>
    );
  }
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--0!./src/sgwt-mini-footer/components/ContactUs.tsx